(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-variant-dropdown"] && !Shopify.designMode) return;
  try {
    class CustomSelect extends HTMLElement {
    connectedCallback() {
      this.isOpen = false;
      this.cache();
      this.bind();
      this.setupMasterInputListener();
    }

    setupMasterInputListener() {
      // Find the product form's master input (variant ID) using the form ID
      const formId = this.dataset.productFormId;
      const productForm = document.getElementById(formId);
      if (productForm) {
        const masterInput = productForm.querySelector('input[name="id"]');
        if (masterInput) {
          
          // Listen for value changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                this.syncWithRealOptions();
              }
            });
          });
          
          observer.observe(masterInput, { 
            attributes: true, 
            attributeFilter: ['value'] 
          });
          
          // Also listen for change events
          masterInput.addEventListener('change', () => {
            this.syncWithRealOptions();
          });
          
          // Initial sync
          this.syncWithRealOptions();
        }
      }
    }

    syncWithRealOptions() {
      const formId = this.dataset.productFormId;
      const productForm = document.getElementById(formId);
      
      if (!productForm) return;
      
      // Find all real options in the form
      const realOptions = productForm.querySelectorAll('option, input[type="radio"]');
      
      // Update custom options based on real options state
      this.options.forEach((customOption) => {
        const optionValue = customOption.dataset.value;
        let isDisabled = false;
        
        // Check if this value exists in real options and is disabled
        realOptions.forEach((realOption) => {
          if (realOption.value === optionValue) {
            // Check both disabled attribute and disabled class
            const hasDisabledAttribute = realOption.hasAttribute('disabled') || realOption.disabled;
            const hasDisabledClass = realOption.classList.contains('disabled');
            
            if (hasDisabledAttribute || hasDisabledClass) {
              isDisabled = true;
            }
          }
        });
        
        // Update custom option state
        if (isDisabled) {
          customOption.classList.add('is-disabled');
          customOption.setAttribute('aria-disabled', 'true');
          customOption.removeAttribute('tabindex');
        } else {
          customOption.classList.remove('is-disabled');
          customOption.removeAttribute('aria-disabled');
          customOption.setAttribute('tabindex', '-1');
        }
      });
    }

    cache() {
      this.root = this.querySelector('.cselect');
      this.trigger = this.querySelector('.cselect__trigger');
      this.valueEl = this.querySelector('.cselect__value');
      this.panel = this.querySelector('.cselect__panel');
      this.options = Array.from(this.querySelectorAll('.cselect__option'));
    }

    bind() {
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (e) => this.handleTriggerKeydown(e));

      this.options.forEach((option) => {
        if (option.classList.contains('is-disabled')) return;
        option.setAttribute('tabindex', '-1');
        option.addEventListener('click', () => this.select(option));
        option.addEventListener('keydown', (e) => this.handleOptionKeydown(e, option));
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.close();
      });
    }

    handleTriggerKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!this.isOpen) this.open();
        const enabled = this.enabledOptions();
        const active = enabled.find(o => o.classList.contains('is-active'));
        (active ?? (e.key === 'ArrowUp' ? enabled[enabled.length - 1] : enabled[0]))?.focus();
      } else if (e.key === 'Escape') {
        this.close();
      }
    }

    handleOptionKeydown(e, option) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.nextOption(option)?.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.prevOption(option)?.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.select(option);
        this.trigger.focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        this.trigger.focus();
      } else if (e.key === 'Tab') {
        this.close();
      }
    }

    enabledOptions() {
      return this.options.filter(o => !o.classList.contains('is-disabled'));
    }

    nextOption(current) {
      const enabled = this.enabledOptions();
      const idx = enabled.indexOf(current);
      return enabled[idx + 1] ?? enabled[0];
    }

    prevOption(current) {
      const enabled = this.enabledOptions();
      const idx = enabled.indexOf(current);
      return enabled[idx - 1] ?? enabled[enabled.length - 1];
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.root.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      const enabled = this.enabledOptions();
      const active = enabled.find(o => o.classList.contains('is-active'));
      (active ?? enabled[0])?.focus();
    }

    close() {
      this.isOpen = false;
      this.root.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    select(option) {
      this.options.forEach((o) => {
        o.classList.remove('is-active');
        o.setAttribute('aria-selected', 'false');
      });

      option.classList.add('is-active');
      option.setAttribute('aria-selected', 'true');

      this.valueEl.innerHTML = option.innerHTML;

      // Find and update the reference element
      const referenceId = this.dataset.referenceId;
      if (referenceId) {
        const referenceElement = document.getElementById(referenceId);
        
        if (referenceElement && referenceElement.tagName === 'SELECT') {
          // Update the select value
          referenceElement.value = option.dataset.value;
          
          // Update the selected option
          const options = referenceElement.querySelectorAll('option');
          options.forEach(opt => {
            if (opt.value === option.dataset.value) {
              opt.selected = true;
              opt.setAttribute('selected', 'selected');
            } else {
              opt.selected = false;
              opt.removeAttribute('selected');
            }
          });
          
          // Trigger change event
          referenceElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Dispatch change event for form integration
      this.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        detail: { value: option.dataset.value }
      }));

      this.close();
    }
  }

  customElements.define('custom-select', CustomSelect);
  } catch(e) { console.error(e); }
})();

})();
